export default "__VITE_ASSET__DvDcLucZ__"